<template>
  <v-layout row justify-center>
    <v-dialog v-model="visibility" persistent max-width="500px">
      <v-card class="px-2">
        <v-card-title>
          <span class="title">{{formTitle}}</span>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-form v-model="valid" ref="form">
            <v-container grid-list-md fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                    dense
                    :items="categories"
                    item-value="id"
                    item-text="name"
                    v-model="editedExpense.category_id"
                    :rules="[required]"
                    label="Category"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editedExpense.description"
                    :rules="[required]"
                    label="Description"
                    required
                    rows="4"
                  ></v-textarea>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    v-model="editedExpense.amount"
                    :rules="[required]"
                    label="Amount"
                    type="number"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <date-picker
                    v-model="editedExpense.date"
                    :rules="[required]"
                    label="Date"
                    required
                  ></date-picker>
                </v-flex>

                <v-flex xs12 class="text-xs-right">
                  <v-spacer></v-spacer>
                  <v-btn flat @click="close">Cancel</v-btn>
                  <v-btn
                    class="mx-0"
                    :disabled="!valid"
                    :loading="saving"
                    color="primary"
                    @click="save"
                  >Save</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    visibility: {
      type: Boolean,
      required: true
    },
    expense: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      required: v => !!v || "This field is required.",
      valid: true,
      defaultExpense: {
        category_id: "",
        description: "",
        amount: "",
        date: new Date().toISOString().split("T")[0]
      },
      editedExpense: {
        category_id: "",
        description: "",
        amount: "",
        date: new Date().toISOString().split("T")[0]
      },
      editedIndex: -1,
      saving: false
    };
  },
  computed: {
    categories() {
      return this.$store.getters["base/expenseCategories"];
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add New Expense" : "Edit Expense";
    }
  },
  methods: {
    close() {
      this.$emit("update:visibility", false);
      this.saving = false;
      this.$refs.form.reset();
      Object.assign(this.editedExpense, this.defaultExpense);
      this.editedIndex = -1;
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        if (this.editedIndex > -1) {
          await this.axios.put(
            `api/expenses/${this.editedExpense.id}`,
            this.editedExpense
          );
        } else {
          await this.axios.post("api/expenses", this.editedExpense);
        }

        this.$emit("saved");

        this.close();
      }
    }
  },
  watch: {
    expense(val) {
      if (val) {
        this.editedExpense = { ...val, category_id: val.category.id };
        this.editedIndex = val.id;
      }
    }
  },
  mounted() {
    this.$store.dispatch("base/loadExpenseCategories");
  }
};
</script>